<div class="glippy-chart" *ngIf="series">
  <div class="glippy-chart__heading" *ngIf="data.title">{{ data.title }}</div>
  <div class="glippy-chart__title">{{ series.label }}</div>
  <div class="glippy-chart__body">
    <div class="glippy-chart__row" *ngFor="let category of data.categories; let i = index">
      <span class="glippy-chart__label" [title]="category">{{ category }}</span>
      <span class="glippy-chart__track">
        <span class="glippy-chart__bar" [style.width.%]="barPercent(valueAt(i))"></span>
      </span>
      <span class="glippy-chart__value">{{ formatValue(valueAt(i)) }}</span>
    </div>
  </div>
</div>
